import {
  grayColor,
  dangerColor,
  onyxGreenColor,
  muiTextMutedColor
} from "assets/jss/default/theme";
import { red } from "@mui/material/colors";

const caseStatusTableStyle = {
  caseStatusTableWrapper: {
    width: "100%"
  },
  machineStatusWrapper: {
    width: "100%",
    maxHeight: "50px",
    transition: "max-height 0.5s",
    overflow: "hidden"
  },
  machineStatusExpand: {
    transition: "max-height 0.5s",
    maxHeight: "1500px"
  },
  verticalGap: {
    marginTop: "20px"
  },
  verticalSmallGap: {
    marginTop: "5px"
  },
  verticalGapDouble: {
    marginTop: "25px"
  },
  priortyWrapper: {
    width: "99px",
    "& .MuiButton-label": {
      color: "white",
      fontWeight: "500",
      fontSize: "13px"
    },
    "& .MuiButtonBase-root": {
      padding: "5px !important"
    }
  },
  selectFullWidth: {
    width: "100%"
  },
  severityChip: {
    width: "100%",
    fontSize: "13px",
    height: "30px"
  },
  recommendedInspectionWrapper: {
    marginTop: "5px",
    "& .MuiSelect-select.MuiSelect-select": {
      backgroundColor: "#f4f4f4",
      padding: "15px",
      fontSize: "14px"
    },
    "& .MuiInput-underline:before": {
      border: "none"
    },
    "& .MuiInputLabel-formControl": {
      color: "#b5b1b1",
      zIndex: "10"
    }
  },
  formControl: {
    margin: "0 0 17px 0",
    paddingTop: "27px",
    position: "relative",
    verticalAlign: "unset",
    "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
      color: grayColor[14]
    }
  },
  removePadding: {
    padding: "0px !important"
  },
  removePaddingLeft: {
    paddingLeft: "0px !important"
  },
  smallFont: {
    fontSize: "14px"
  },
  removeBottomBorder: {
    "& .MuiInput-underline:before": {
      borderBottom: "none"
    }
  },
  longTextField: {
    width: "100%",
    "& .MuiInputBase-input": {
      backgroundColor: "#f4f4f4",
      padding: "15px",
      fontSize: "14px"
    },
    "& .MuiInput-underline:before": {
      border: "none"
    }
  },
  priorStatusWrapper: {
    opacity: "0.3",
    pointerEvents: "none",
    zIndex: "10000"
  },
  currentStatusWrapper: {
    backgroundColor: "#E2EAEE",
    "& div": {
      backgroundColor: "#E2EAEE"
    }
  },
  priorWindStatusWrapper: {
    opacity: "0.3",
    pointerEvents: "none",
    zIndex: "10000"
  },
  currentWindStatusWrapper: {
    backgroundColor: "#E2EAEE",
    "& div": {
      backgroundColor: "#E2EAEE"
    }
  },
  timeLine: {
    position: "absolute",
    top: "36px",
    left: "33px",
    zIndex: "10000",
    display: "none"
  },
  showTimeLine: {
    display: "block"
  },
  statusWrapper: {
    position: "relative",
    "&:hover": {
      "& button": {
        display: "block"
      }
    }
  },
  machineStatus: {
    padding: "9px",
    paddingLeft: "15px",
    paddingRight: "15px",
    position: "relative",
    "& .MuiInputBase-root": {
      fontSize: "14px",
      fontWeight: "500"
    },
    "& .MuiSvgIcon-root": {
      width: "17px"
    },
    "& .manager": {
      position: "absolute",
      top: "6px"
    }
  },
  caseStatusWrapper: {
    padding: "10px 10px 10px 10px",
    position: "relative",
    backgroundColor: "#f4f4f4",
    "& .MuiInputBase-root": {
      fontSize: "14px",
      fontWeight: "500"
    },
    "& .MuiSvgIcon-root": {
      width: "17px"
    },
    "& .manager": {
      position: "absolute",
      top: "6px"
    }
  },
  caseStatusTwoLine: {
    "& .MuiButton-label": {
      lineHeight: "9px !important"
    }
  },
  caseStatusGepFirst: {
    marginTop: "20px"
  },
  caseStatusGepSec: {
    marginTop: "20px",
    paddingBottom: "8px"
  },
  caseDueDateGepSec: {
    marginTop: "10px"
  },
  moreVert: {
    padding: "0px",
    position: "absolute",
    top: "19px",
    right: "-9px"
  },
  plusIcon: {
    padding: "0px",
    width: "0px",
    display: "none",
    "& .MuiIcon-fontSizeSmall": {
      fontSize: "13px"
    }
  },
  statusHeaderMargin: {
    marginLeft: "7px"
  },
  statusGepPadding: {
    paddingLeft: "7px !important"
  },
  statusGapDatePadding: {
    paddingLeft: "7px !important",
    marginLeft: "2px"
  },
  paddingLeft15: {
    paddingLeft: "15px"
  },
  oldMachineStatus: {
    backgroundColor: "#f4f4f4",
    height: "50px",
    opacity: "0.8",
    "& .MuiIconButton-root": {
      color: red
    }
  },
  newMachineStatus: {
    backgroundColor: "#E2EAEE",
    height: "50px"
  },
  datepicker: {
    width: "70%",
    "& .MuiButtonBase-root": {
      padding: "0px"
    }
  },
  positionRelative: {
    position: "relative"
  },
  moreVertColor: {
    color: "rgb(177, 171, 171)"
  },
  doubleLineText: {
    fontSize: "10px",
    lineHeight: "9px"
  },
  statusDropdownButton: {
    margin: "0px",
    padding: "5px",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none"
  },
  statusDropdownButtonWithBack: {
    margin: "0px",
    padding: "5px",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    backgroundColor: "rgba(0, 0, 0, 0.4)"
  },
  statusDropdownButtonWithDark: {
    margin: "0px",
    padding: "5px",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    backgroundColor: "#4a4a4a"
  },
  dropdownEllipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    justifyContent: "flex-start"
  },
  removeValidation: {
    "& .MuiInput-underline.Mui-error::after": {
      transform: "scaleX(0)"
    }
  },
  statusLastIcon: {
    marginRight: "-3px"
  },
  statusIconWrapper: {
    float: "right",
    marginBottom: "6px",
    paddingRight: "15px"
  },
  redColor: {
    "& .MuiInputBase-input": {
      color: dangerColor[0]
    }
  },
  nonCurrentCase: {
    color: onyxGreenColor,
    textDecoration: "underline"
  },
  currentCase: {
    color: muiTextMutedColor,
    pointerEvents: "none"
  }
};

export default caseStatusTableStyle;
